import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLocationTick = (props: SVGProps<SVGSVGElement>) => (
  <svg xmlns='http://www.w3.org/2000/svg' width={20} height={20} fill='none' {...props}>
    <g stroke='rgb(var(--blue-1))' strokeWidth={1.5}>
      <path d='M3.017 7.075C4.658-.142 15.35-.133 16.983 7.083c.959 4.234-1.675 7.817-3.983 10.034a4.33 4.33 0 0 1-6.008 0c-2.3-2.217-4.934-5.809-3.975-10.042Z' />
      <path strokeLinecap='round' strokeLinejoin='round' d='m7.709 9.583 1.25 1.25L12.292 7.5' />
    </g>
  </svg>
);
export default SvgLocationTick;
